import { IncidentStatusOption } from "@/graphql/generated"
import { SmallInfoCard } from "./SmallInfoCard"
import activeIcon from '@/assets/incidents-icons/active-icon.svg'
import inactiveIcon from '@/assets/incidents-icons/inactive-icon.svg'
import terminatedIcon from '@/assets/incidents-icons/terminated-icon.svg'
import { useUserLanguage } from "@/customHooks"

type IncidentStatusMapperWithIconProps = {
  statusOption: IncidentStatusOption
}

const textsData = {
  en: {
    newCard: { title: 'Status', value: 'New' },
    pendingCard: { title: 'Status', value: 'Pending' },
    assignedCard: { title: 'Status', value: 'Assigned' },
    scheduledCard: { title: 'Status', value: 'Scheduled' },
    resolvedCard: { title: 'Status', value: 'Resolved' },
    completedCard: { title: 'Status', value: 'Completed' },
    cancelledCard: { title: 'Status', value: 'Cancelled' },
  },
  es: {
    newCard: { title: 'Estado', value: 'Nuevo' },
    pendingCard: { title: 'Estado', value: 'Pendiente' },
    assignedCard: { title: 'Estado', value: 'Asignado' },
    scheduledCard: { title: 'Estado', value: 'Programado' },
    resolvedCard: { title: 'Estado', value: 'Resuelto' },
    completedCard: { title: 'Estado', value: 'Completado' },
    cancelledCard: { title: 'Estado', value: 'Cancelado' },
  }
}

export const IncidentStatusMapperWithIcon = ({ statusOption }: IncidentStatusMapperWithIconProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  switch (statusOption) {
    case IncidentStatusOption.New:
      return (
        <SmallInfoCard
          icon={activeIcon}
          title={texts.newCard.title}
          value={texts.newCard.value}
        />
      )
    case IncidentStatusOption.Pending:
      return (
        <SmallInfoCard
          icon={inactiveIcon}
          title={texts.pendingCard.title}
          value={texts.pendingCard.value}
        />
      )
    case IncidentStatusOption.Assigned:
      return (
        <SmallInfoCard
          icon={inactiveIcon}
          title={texts.assignedCard.title}
          value={texts.assignedCard.value}
        />
      )
    case IncidentStatusOption.Scheduled:
      return (
        <SmallInfoCard
          icon={inactiveIcon}
          title={texts.scheduledCard.title}
          value={texts.scheduledCard.value}
        />
      )
    case IncidentStatusOption.Resolved:
      return (
        <SmallInfoCard
          icon={inactiveIcon}
          title={texts.resolvedCard.title}
          value={texts.resolvedCard.value}
        />
      )
    case IncidentStatusOption.Completed:
      return (
        <SmallInfoCard
          icon={inactiveIcon}
          title={texts.completedCard.title}
          value={texts.completedCard.value}
        />
      )
    case IncidentStatusOption.Cancelled:
      return (
        <SmallInfoCard
          icon={terminatedIcon}
          title={texts.cancelledCard.title}
          value={texts.cancelledCard.value}
        />
      )
    default:
      return null
  }
}